import { render, staticRenderFns } from "./CheckoutControlPaymentBankTransfer.vue?vue&type=template&id=11e7a85d&scoped=true&"
import script from "./CheckoutControlPaymentBankTransfer.vue?vue&type=script&lang=js&"
export * from "./CheckoutControlPaymentBankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e7a85d",
  null
  
)

export default component.exports